/*
 * Projects floating image
*/
	let enableFloating = false
	const siteDevsFloating = document.querySelector('[site-projects-float]');
	const siteDevsInline = document.querySelectorAll('.inline--i')
	const siteDevsContainer = document.querySelector('[site-projects-container]')

	if (siteDevsInline.length > 0 && siteDevsFloating) {
		// follow pointer
		document.addEventListener('mousemove', e => {
			if (enableFloating) {
				siteDevsFloating.style.left = e.pageX + 'px';
				siteDevsFloating.style.top = e.pageY + 'px';
			} else {
				siteDevsFloating.style = ''
			}
		})

		// show floating image
		siteDevsContainer.addEventListener('mouseover', _ => {
			enableFloating = true
			siteDevsFloating.classList.add('is--visible')
		})

		// hide floating image
		siteDevsContainer.addEventListener('mouseout', _ => {
			siteDevsFloating.classList.remove('is--visible')
			enableFloating = false
		})

		// mouse enter - item
		siteDevsInline.forEach((element, key) => {
			element.addEventListener('mouseover', e => {
				const image = element.querySelector('picture').innerHTML

				siteDevsFloating.style.setProperty('--z', `${(key + 1) * 2}deg`)
				siteDevsFloating.innerHTML = image
			})
		})
	}
